// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_ug2","cls2":"WorkCard-cls2_dwl WorkCard-cls1_ug2"};